export default __webpack_public_path__ + "assets/6cebcea7745af095f924e96b2c056c3b.svg";